module.exports = __webpack_public_path__ + "img/beer_id-87.02a6d80d.png";